/* eslint-disable import/no-extraneous-dependencies */
import { createRoot } from 'react-dom/client';

import '@april9au/stack9-ui/dist/index.css';

import * as emailModule from '@april9au/stack9-email-ui';
import * as mktModule from '@april9au/stack9-marketing-ui';
import * as s9PagesModuleUi from '@april9au/stack9-pages-ui';
import { AppProvider, AuthProvider } from '@april9au/stack9-react';
import {
  Alert,
  App,
  AppContextProvider,
  Avatar,
  axiosProvider,
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  Calendar,
  Card,
  Collapse,
  CollapsePanel,
  Container,
  DescriptionItem,
  Descriptions,
  Empty,
  Image,
  LayoutContent,
  LayoutFooter,
  LayoutHeader,
  LayoutSider,
  Menu,
  Modal,
  Pagination,
  Paragraph,
  Progress,
  RadioGroup,
  Rate,
  reportWebVitals,
  S9Button,
  S9Checkbox,
  S9Col,
  S9CustomEntityFormPage,
  S9DateField,
  S9EntityActions,
  S9EntityWorkflowActions,
  S9EntityWorkflowHistory,
  S9Fieldset,
  S9FileField,
  S9Form,
  S9Layout,
  S9MonacoEditorField,
  S9MultiDropDown,
  S9NumericField,
  S9OptionSet,
  S9PageContent,
  S9PageHeader,
  S9PageTitle,
  S9Row,
  S9SingleDropDown,
  S9Table,
  S9Tabs,
  S9TextField,
  S9RichTextEditor,
  SaveFilterButton,
  Select,
  Skeleton,
  Spin,
  stack9Config,
  Statistic,
  Step,
  Steps,
  Switch,
  TabPane,
  Timeline,
  TimelineItem,
  TimePicker,
  UIProvider,
  S9Grid,
} from '@april9au/stack9-ui';
import { ConfigProvider } from 'antd';

import './App.css';

import { ActionBarComponent } from './components/ActionBarComponent';
import * as SlotDateTimeCell from './components/SlotDateTimeCell/SlotDateTimeCell';
import * as CustomResourceMultiDropdown from './components/Topic/CustomResourceMultiDropdown';
import { BookingDetailScreen } from './pages/BookingDetailScreen';
import { EventDetailScreen } from './pages/EventDetailScreen';
import { HealthScreenDetail } from './pages/HealthScreenDetail';
import { PermissionSetDetailView } from './pages/permission-set/PermissionSetDetailView';
import { ResourceDetail } from './pages/ResourceDetail';

const components = [
  S9Button,
  Alert,
  Avatar,
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  Calendar,
  Card,
  S9Col,
  Collapse,
  CollapsePanel,
  Container,
  DescriptionItem,
  Descriptions,
  Empty,
  Image,
  S9Layout,
  LayoutContent,
  LayoutFooter,
  LayoutHeader,
  LayoutSider,
  Menu,
  Modal,
  Pagination,
  Paragraph,
  Progress,
  RadioGroup,
  Rate,
  S9Row,
  Select,
  Skeleton,
  Spin,
  Statistic,
  Step,
  Steps,
  Switch,
  S9Table,
  TabPane,
  S9Tabs,
  Timeline,
  TimelineItem,
  TimePicker,
  S9PageTitle,
  S9PageHeader,
  S9PageContent,
  S9EntityWorkflowActions,
  S9EntityWorkflowHistory,
  S9EntityActions,
  S9FileField,
  S9TextField,
  S9RichTextEditor,
  S9Form,
  S9Fieldset,
  S9OptionSet,
  S9SingleDropDown,
  S9MultiDropDown,
  S9DateField,
  S9NumericField,
  S9Checkbox,
  S9MonacoEditorField,
  SaveFilterButton,
  S9CustomEntityFormPage,
  S9Grid,
  CustomResourceMultiDropdown,
  SlotDateTimeCell,
  ...emailModule.components,
  ...mktModule.components,
  ...s9PagesModuleUi.components,
];

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <AppProvider axiosFactory={axiosProvider} config={stack9Config}>
    <AuthProvider
      clientId="" // backoffice does not require clientId
      onError={err => {
        console.error(err);
      }}
    >
      <UIProvider components={components} extensions={{ ActionBarComponent }}>
        <AppContextProvider>
          <ConfigProvider>
            <App
              customRoutes={[
                {
                  route: '/health-screen-detail/:id',
                  component: <HealthScreenDetail />,
                },
                {
                  route: '/resource-detail/:id',
                  component: <ResourceDetail />,
                },
                {
                  route: '/event-detail/:id',
                  component: <EventDetailScreen />,
                },
                {
                  route: '/booking-detail/:id',
                  component: <BookingDetailScreen />,
                },
                {
                  route: '/permission-set/:id',
                  component: <PermissionSetDetailView />,
                },
                ...emailModule.customRoutes,
                ...mktModule.customRoutes,
                ...s9PagesModuleUi.customRoutes,
              ]}
            />
          </ConfigProvider>
        </AppContextProvider>
      </UIProvider>
    </AuthProvider>
  </AppProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
